<template>
  <div>
    <a-spin :spinning="loading">
      <a-form ref="formRef" :model="modelRef" @finish="onSearch">
        <a-row>
          <a-col :span="10">
            <a-button style="margin-right: 20px;" type="primary" html-type="submit">搜索</a-button>
          </a-col>
          <a-col :span="14" style="text-align: right;">
          </a-col>
        </a-row>
      </a-form>
      <a-table style="margin-top: 10px;" :dataSource="dataList" :pagination="pagination" :columns="columns" bordered size="middle"
               :scroll="{ x: 1000 }"
               tableLayout="fixed"
               rowKey="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'operate'">
            <a @click="onEdit(record)">编辑</a>
          </template>
        </template>
      </a-table>
      <a-modal v-model:visible="editVisible" title="编辑" @ok="onSubmit" @cancel="onCancel">
        <a-form ref="editFormRef" :model="editModelRef">
          <a-form-item label="code" name="code" :rules="[{ required: true, message: '必填项不允许为空' }]">
            <a-input v-model:value="editModelRef.code" :disabled="true"></a-input>
          </a-form-item>
          <a-form-item label="dataKey" name="dataKey" :rules="[{ required: true, message: '必填项不允许为空' }]">
            <a-input v-model:value="editModelRef.dataKey" :disabled="true"></a-input>
          </a-form-item>
          <a-form-item label="dataValue" name="dataValue" :rules="[{ required: false, message: '必填项不允许为空' }]">
            <a-textarea :rows="4" v-model:value="editModelRef.dataValue"/>
          </a-form-item>
          <a-form-item label="description" name="description" :rules="[{ required: true, message: '必填项不允许为空' }]">
            <a-input v-model:value="editModelRef.description" :disabled="true"></a-input>
          </a-form-item>
        </a-form>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
  import {
    getDataDictList,
    getDataDictDetail,
    updateDataDict
  } from '@/service/modules/system';
  import {
    Icon
  } from "@/components/icon/icon.js";
  export default {
    components: {
      Icon
    },
    data() {
      return {
        loading: false,
        modelRef: {},
        searchData: {},
        dataList: [],
        columns: [
          {
            title: "id",
            dataIndex: "id",
            width: 50,
          },
          {
            title: "code",
            dataIndex: "code",
            width: 50,
          },
          {
            title: "dataKey",
            dataIndex: "dataKey",
            width: 100,
          },
          {
            title: "dataValue",
            dataIndex: "dataValue",
            width: 200,
            maxWidth: 200,
          },
          {
            title: "description",
            dataIndex: "description",
            width: 100,
          },
          {
            title: "操作",
            key: "operate",
            width: 100,
          },
        ],
        pagination: {
          showSizeChanger: true,
          showQuickJumper: true,
          size: "middle",
          showTotal: (total) => {
            return "共 " + total + " 条";
          },
          total: 0,
          current: 1,
          pageSize: 20,
          onChange: (page) => {
            this.pagination.current = page;
            this.getData();
          },
          onShowSizeChange: (page, pageSize) => {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getData();
          }
        },
        editVisible: false,
        editModelRef: {},
      }
    },
    created() {
      this.getData();
    },
    methods: {
      onEdit(record) {
        this.editVisible = true;
        this.editModelRef = {...record};
      },
      onCancel() {
        this.editVisible = false;
        this.editModelRef = {};
      },
      onSubmit() {
        this.loading = true;
        updateDataDict(this.editModelRef).then(res => {
          this.onSearch();
          this.editVisible = false;
          this.editModelRef = {};
          this.loading = false;
        }).catch(e=>{
          this.loading = false;
        })
      },
      onSearch() {
        this.pagination.current = 1;
        this.searchData = JSON.parse(JSON.stringify(this.modelRef));
        this.getData();
      },
      resetBtn() {
        this.$refs.formRef.resetFields();
        this.onSearch();
      },
      getData() {
        this.loading = true;
        getDataDictList({
          page: this.pagination.current,
          pageSize: this.pagination.pageSize,
          ...this.searchData
        }).then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.dataList = res.data.list;
            this.pagination.total = res.data.totalCount;
          }
        })
      }
    }
  };
</script>

<style lang="less" scoped>

</style>
